import { css } from 'styled-components'

import designTokens from './designTokens'

type DesignTokens = typeof designTokens

export type TextRole = {
  [K in keyof DesignTokens]: DesignTokens[K] extends { fontFamily: string }
    ? K
    : never
}[keyof DesignTokens]

const typeStyle = (role: TextRole) => {
  const token = designTokens[role]
  if (!token || typeof token === 'string') {
    throw new Error(`Unknown text role: ${role}`)
  }
  return css`
    font-family: ${token.fontFamily};
    font-size: ${token.fontSize};
    font-weight: ${token.fontWeight};
    line-height: ${token.lineHeight};
  `
}

export default typeStyle
